import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

type Props = {
    active: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    active: { type: Boolean, required: true }
  },
  setup(__props: any) {

const props = __props as {
    active: boolean
}


return (_ctx: any,_cache: any) => {
  const _component_IconCheck = _resolveComponent("IconCheck")!
  const _component_IconCross = _resolveComponent("IconCross")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"height":"30px","width":"30px"},
    class: _normalizeClass(["rounded-full flex justify-center items-center lg:mx-auto", props.active ? 'bg-green' : 'bg-red'])
  }, [
    (props.active)
      ? (_openBlock(), _createBlock(_component_IconCheck, { key: 0 }))
      : (_openBlock(), _createBlock(_component_IconCross, {
          key: 1,
          style: {"transform":"rotate(45deg)"}
        }))
  ], 2))
}
}

})